export function isDemoUser() {
  return localStorage.getItem('username') === 'demo';
}

export function isDemoSupplier(supplier) {
  return isDemoUser() || supplier === 'DEMO';
}

export function getDemoUrl(url) {
  return url
    .replace('/rep_sales/', '/rep_sales_demo/')
    .replace('/rep_strikeRate/', '/rep_strikeRate_demo/')
    .replace('/rep_ranging/', '/rep_ranging_demo/')
    .replace('/rep_margin/', '/rep_margin_demo/');
}
